export default {
	name: "KModelProxy",

	props: {
		value: { required: true }
	},

	watch: {
		value( val ) {
			this.$emit( "input", val );
		}
	},

	render() {
		return this.$scopedSlots.default();
	}
};
